import { IAppLogState, IFetchAppLogs, IAppLogResponse } from "@/pages/SmartCoolers/smartCooler.interface";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState: IAppLogState = {
    appLogs: {
        data: [],
        pagination: {
            totalRecords: 0,
            currentPage: 1,
            totalPages: 0,
            currentLimit: 50,
        },
        success: false,
        message: "",
    },
    listLoading: false,
    appendLoading: false,
    downloadLoading: false,
    downloadError: null,
    error: false,
};

const appLogSlice = createSlice({
    name: "appLog",
    initialState,
    reducers: {
        getAppLogs: (state, _action: PayloadAction<IFetchAppLogs>) => {
            state.listLoading = true;
            state.error = false;
        },
        getAppLogsSuccess: (state, action: PayloadAction<IAppLogResponse>) => {
            state.listLoading = false;
            state.appLogs = { ...action.payload };
        },
        getMoreAppLogs: (state, _action: PayloadAction<IFetchAppLogs>) => {
            state.appendLoading = true;
        },
        getMoreAppLogsSuccess: (state, action: PayloadAction<IAppLogResponse>) => {
            state.appendLoading = false;
            state.appLogs = {
                ...action.payload,
                data: [...state.appLogs.data, ...action.payload.data],
            };
        },
        getAppLogsFailure: (state, action: PayloadAction<any>) => {
            state.listLoading = false;
            state.error = true;
            state.appLogs = {
                success: false,
                data: [],
                pagination: initialState.appLogs.pagination,
                message: action.payload?.messageDetails?.length
                    ? action.payload.messageDetails[0]?.message
                    : action.payload?.message,
            };
        },
        downloadAppLog: (state, _action: PayloadAction<{ logId: string }>) => {
            state.downloadLoading = true;
            state.downloadError = null;
        },
        downloadAppLogSuccess: (state) => {
            state.downloadLoading = false;
            state.downloadError = null;
        },
        downloadAppLogFailure: (state, action: PayloadAction<string | undefined>) => {
            state.downloadLoading = false;
            state.downloadError = action.payload ?? "Download failed.";
        },
        resetAppLogs: (state) => {
            state.appLogs = initialState.appLogs;
            state.listLoading = false;
            state.appendLoading = false;
            state.error = false;
        },
        clearAppLogsError: (state) => {
            state.error = false;
        },
    },
});

export const {
    getAppLogs,
    getAppLogsSuccess,
    getAppLogsFailure,
    getMoreAppLogs,
    getMoreAppLogsSuccess,
    downloadAppLog,
    downloadAppLogSuccess,
    downloadAppLogFailure,
    resetAppLogs,
    clearAppLogsError,
} = appLogSlice.actions;

export default appLogSlice.reducer;
